module.exports = __webpack_public_path__ + "img/Line-Big.3c81c573.svg";